import React from 'react'

import PropTypes from 'prop-types'

import { Container, Button, Dropdown, Image } from 'react-bootstrap'

import CartIcon from '../icons/CartIcon'

import styles from './../style/Footer.module.scss'

import ConsultationForm from './ConsultationFormF'
import PhoneDropdown from './PhoneDropdown'
import FeedbackForm from './FeedbackForm'
import SearchContainer from './SearchContainer'

class Footer extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      isPhoneDropdownOpen: false,
      isCatalogDropdownOpen: false,
      show_feedback: false
    };
    
    this.worktime = 'worktime' in props.options ? props.options.worktime : { one: '', two: '', opt: '' }

    this.toggleCatalogDropdown = this.toggleCatalogDropdown.bind(this);
  }
  
  toggleCatalogDropdown() {
    this.setState(prevState => ({
      isCatalogDropdownOpen: !prevState.isCatalogDropdownOpen
    }));
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.show_feedback !== nextState.show_feedback ||
      this.state.isCatalogDropdownOpen !== nextState.isCatalogDropdownOpen ||
      this.props.authorized !== nextProps.authorized
    );
  }

  render() {
    const {
      isCatalogDropdownOpen,
      show_feedback
    } = this.state,
    { options, user_profile_type, catalog, menu, changeSearch, changeTopSearch, authorized, cart } = this.props

    return (
      <footer className={styles.footer}>
        {/* Первая строка - контакты */}
        <div className={styles.topRow}>
          <Container className={styles.container}>

            <div className={styles.mobftop + ' d-flex d-md-none align-items-center justify-content-between'}>
              <a className={styles.logo} href="/">
                <Image alt="stomahelp.ru" src='/images/newlogostoma.svg' width="146" height="32" />
              </a>
              <Button onClick={() => this.showFeedback()} className='text-white px-5' variant='primary'>Связаться</Button>
            </div>

            <div className={styles.topRowContent}>
              <div className={styles.contactsWrapper}>

                <div className={styles.mobAdresRow + ' d-md-none'}>
                  <div className='d-flex align-items-center mb-2'>
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.49906 9.51277C9.71961 9.51277 10.7091 8.52332 10.7091 7.30277C10.7091 6.08222 9.71961 5.09277 8.49906 5.09277C7.27851 5.09277 6.28906 6.08222 6.28906 7.30277C6.28906 8.52332 7.27851 9.51277 8.49906 9.51277Z" stroke="#1D91DF" stroke-width="1.2"/>
                      <path d="M2.56453 6.01408C3.95995 -0.120089 13.0479 -0.113006 14.4362 6.02116C15.2508 9.61949 13.0124 12.6653 11.0504 14.5495C9.62661 15.9237 7.37411 15.9237 5.94328 14.5495C3.98828 12.6653 1.74995 9.61241 2.56453 6.01408Z" stroke="#1D91DF" stroke-width="1.2"/>
                    </svg>
                    <div className='ms-2'>г. Нижний Новгород, ул. Белинского, 32</div>
                  </div>
                  <div className='d-flex align-items-center justify-content-between'>
                    {/* TG */}
                    {'tglink' in options &&
                      <a href={options.tglink} target="_blank" rel="noopener noreferrer">
                        <Image alt="TG" src={options?.tgicon || ''} width="38" height="38" />
                      </a>
                    }

                    {/* WA */}
                    {'walink' in options &&
                      <a href={options.walink} target="_blank" rel="noopener noreferrer">
                        <Image alt="WA" src={options?.waicon || ''} width="38" height="38" />
                      </a>
                    }

                    <div onClick={changeTopSearch} className={styles.iconsRowMobEl}>
                      <svg style={{ color: '#000', width: '16px', height: '16px' }} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.22448 15.2824C12.5702 15.2824 15.2824 12.5702 15.2824 9.22448C15.2824 5.87875 12.5702 3.1665 9.22448 3.1665C5.87875 3.1665 3.1665 5.87875 3.1665 9.22448C3.1665 12.5702 5.87875 15.2824 9.22448 15.2824Z" stroke="#3A3A3A" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M15.8333 15.8333L14.1812 14.1812" stroke="#3A3A3A" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>

                    <a href={options?.link_cart || '/'} className={styles.iconsRowMobEl}>
                      <CartIcon />
                      <span className='d-none'>Корзина</span>
                    </a>

                    {user_profile_type != `legal` &&
                      <Dropdown 
                        show={isCatalogDropdownOpen}
                        drop={`up`}
                        onToggle={this.toggleCatalogDropdown}
                        className={styles.catalogDropdown}
                      >
                        <Dropdown.Toggle as={Button} variant="primary" className={styles.catalogButton}>
                          <Image alt="Кат" className="me-2" src="/images/catalog.svg" width="17" height="11" />
                          Открыть каталог
                        </Dropdown.Toggle>

                        <Dropdown.Menu className={styles.catalogMenu}>
                          {catalog.map((item, index) => (
                            <Dropdown.Item 
                              key={index} 
                              className={styles.catalogItem}
                              active={item.is_current}
                              as="a"
                              href={item.link}
                            >
                              <span dangerouslySetInnerHTML={{__html: item.pagetitle.replace(/<[^>]+>/g, ' ')}} />
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    }

                  </div>
                </div>

                {/* Поиск */}
                <SearchContainer 
                  onChange={changeSearch} 
                  onSearch={changeTopSearch} 
                  in_footer={true}
                />

                <div className={styles.sep} />

                <div className={styles.tymephoneSection}>

                  {/* Время работы */}
                  <div className={styles.workTimeBlock}>
                    <Image alt="Время" className="me-2" src="/images/worktime.svg" width="16" height="16" />
                    <div>
                      <div className={styles.workTimeText}>{this.worktime.one}</div>
                      <div className={styles.workTimeSubtext}>{user_profile_type == `legal` ? this.worktime.opt : this.worktime.two}</div>
                    </div>
                  </div>

                  <div className={styles.workTimeBlockSpSep}></div>

                  {/* Телефон с выпадающим меню */}
                  <PhoneDropdown options={options} userProfileType={user_profile_type} />

                </div>

                <div className={styles.emailSection}>
                  {user_profile_type != `legal` ?
                    <div className={styles.emailBlock}>
                      <div className={styles.emailHeader}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.751 15.375H5.25098C3.00098 15.375 1.50098 14.25 1.50098 11.625V6.375C1.50098 3.75 3.00098 2.625 5.25098 2.625H12.751C15.001 2.625 16.501 3.75 16.501 6.375V11.625C16.501 14.25 15.001 15.375 12.751 15.375Z" stroke="#E10611" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M12.749 6.75L10.4015 8.625C9.62902 9.24 8.36152 9.24 7.58902 8.625L5.24902 6.75" stroke="#E10611" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>Написать нам</span>
                      </div>
                      <a href={`mailto:${options?.onsitemail}`} className={styles.emailText}>{options?.onsitemail || ``}</a>
                    </div>
                  :
                    <div className={styles.emailBlock}>
                      <div className={styles.emailHeader}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.751 15.375H5.25098C3.00098 15.375 1.50098 14.25 1.50098 11.625V6.375C1.50098 3.75 3.00098 2.625 5.25098 2.625H12.751C15.001 2.625 16.501 3.75 16.501 6.375V11.625C16.501 14.25 15.001 15.375 12.751 15.375Z" stroke="#E10611" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M12.749 6.75L10.4015 8.625C9.62902 9.24 8.36152 9.24 7.58902 8.625L5.24902 6.75" stroke="#E10611" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>Написать нам</span>
                      </div>
                      <a href={`mailto:${options?.onsitemailopt}`} className={styles.emailText}>{options?.onsitemailopt || ``}</a>
                    </div>
                  }
                </div>

                <div className={styles.sep} />

                <Button onClick={() => this.showFeedback()} className='text-white d-none d-xl-block' variant='primary'>Связаться</Button>
                <FeedbackForm
                  title={`Нужна консультация?`}
                  text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                  btn={`Отправить`}
                  data={[]}
                  show={show_feedback}
                  handleClose={() => this.closeFeedback()}
                />

              </div>
            </div>
          </Container>
        </div>
        
        <div className={styles.divider}></div>
        
        {/* Основное содержимое футера */}
        <div className={styles.middleRow}>
          <Container className={styles.container}>
            <div className='d-flex flex-column flex-md-row justify-content-between'>
              <div className={styles.logoCol}>
                <a className={styles.logo} href="/">
                  <Image alt="stomahelp.ru" src='/images/newlogostoma.svg' width="150" height="33" />
                </a>
                {user_profile_type != `legal` &&
                  <Dropdown 
                    show={isCatalogDropdownOpen}
                    drop={`up`}
                    onToggle={this.toggleCatalogDropdown}
                    className={styles.catalogDropdown}
                  >
                    <Dropdown.Toggle as={Button} variant="primary" className={styles.catalogButton}>
                      <Image alt="Кат" className="me-2" src="/images/catalog.svg" width="17" height="11" />
                      Каталог
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={styles.catalogMenu}>
                      {catalog.map((item, index) => (
                        <Dropdown.Item 
                          key={index} 
                          className={styles.catalogItem}
                          active={item.is_current}
                          as="a"
                          href={item.link}
                        >
                          <span dangerouslySetInnerHTML={{__html: item.pagetitle.replace(/<[^>]+>/g, ' ')}} />
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                }

                <div className={styles.infoText}>
                  {user_profile_type == `legal` ? <>ООО "СТОМАХЕЛП"</> : <>ИП Ушаков Иван Иванович</>}<br />
                  603000, Россия, Нижегородская область, г. Нижний Новгород, ул. Белинского, д. 32, п. 4<br />
                  {user_profile_type == `legal` ?
                    <a href="/assets/rekviziti_ul.pdf" target="_blank">Реквизиты</a>
                  :
                    <a href="/assets/rekviziti2.pdf" target="_blank">Реквизиты</a>
                  }
                </div>
              </div>
              
              <div className={styles.linksCol}>
                <h3 className={styles.linksTitle}>Информация</h3>
                <ul className={styles.linksList}>
                  <li><a href="/" className={styles.linkItem}>Главная</a></li>
                  {menu.map((item, key) => (
                    <li key={key}>
                      <a href={item.link} className={styles.linkItem}>{item.pagetitle}</a>
                    </li>
                  ))}
                </ul>

                <div className='d-flex mt-3' style={{ gap: `54px` }}>
                  {/* TG */}
                  {'tglink' in options &&
                    <a className='d-none d-md-flex' href={options.tglink} target="_blank" rel="noopener noreferrer">
                      <Image alt="TG" src={options?.tgicon || ''} width="22" height="22" />
                    </a>
                  }

                  {/* WA */}
                  {'walink' in options &&
                    <a className='d-none d-md-flex' href={options.walink} target="_blank" rel="noopener noreferrer">
                      <Image alt="WA" src={options?.waicon || ''} width="22" height="22" />
                    </a>
                  }
                </div>
              </div>
              
              <div className={styles.linksCol}>
                <h3 className={styles.linksTitle}>Наши предложения</h3>
                <ul className={styles.linksList}>
                  {catalog.map((item, index) => {
                    if( index < ( catalog.length - 1) ) return (
                      <li key={index}>
                        <a href={item.link} className={styles.linkItem} dangerouslySetInnerHTML={{__html: item.pagetitle.replace(/<[^>]+>/g, ' ')}} />
                      </li>
                    )
                  })}
                </ul>
              </div>
              
              <div className={styles.formCol}>
                <ConsultationForm />
              </div>
            </div>
            <div className={styles.formColMob}>
              <ConsultationForm />
            </div>
          </Container>
        </div>
        
        <div className={styles.divider}></div>
        
        {/* Копирайт */}
        <div className={styles.bottomRow}>
          <Container className={styles.container}>
            <div className={styles.bottomRowContent}>

              <div className={styles.infoTextMob}>
                {user_profile_type == `legal` ? <>ООО "СТОМАХЕЛП"</> : <>ИП Ушаков Иван Иванович</>}<br />
                603000, Россия, Нижегородская область, г. Нижний Новгород, ул. Белинского, д. 32, п. 4<br />
                {user_profile_type == `legal` ?
                  <a href="/assets/rekviziti_ul.pdf" target="_blank">Реквизиты</a>
                :
                  <a href="/assets/rekviziti2.pdf" target="_blank">Реквизиты</a>
                }
              </div>

              <div className={styles.copyright}>
                2005-{(new Date().getFullYear())} © stomahelp.ru. Все права защищены.
              </div>

              {/* Блок с иконками в ряд */}
              <div className={styles.iconsRow}>

                {/* Войти */}
                <a href={options?.link_lk || '/'} className={styles.iconItem}>
                  <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.08509 9.05242C9.03551 9.04534 8.97176 9.04534 8.91509 9.05242C7.66842 9.00992 6.67676 7.98993 6.67676 6.73618C6.67676 5.45409 7.71092 4.41284 9.00009 4.41284C10.2822 4.41284 11.3234 5.45409 11.3234 6.73618C11.3163 7.98993 10.3318 9.00992 9.08509 9.05242Z" stroke="black" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13.7739 13.7275C12.5131 14.8821 10.8414 15.5833 8.99975 15.5833C7.15809 15.5833 5.48642 14.8821 4.22559 13.7275C4.29642 13.0616 4.72142 12.41 5.47934 11.9C7.42017 10.6108 10.5935 10.6108 12.5202 11.9C13.2781 12.41 13.7031 13.0616 13.7739 13.7275Z" stroke="black" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9.00033 15.5834C12.9123 15.5834 16.0837 12.4121 16.0837 8.50008C16.0837 4.58806 12.9123 1.41675 9.00033 1.41675C5.08831 1.41675 1.91699 4.58806 1.91699 8.50008C1.91699 12.4121 5.08831 15.5834 9.00033 15.5834Z" stroke="black" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span className={styles.iconLabel}>{authorized ? `Профиль` : `Войти`}</span>
                </a>

                {/* Корзина */}
                <a href="/korzina/" className={styles.iconItem}>
                  <div className={styles.cartContainer}>
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.24092 1.41675L3.67676 3.988" stroke="black" strokeWidth="1.0625" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M10.7598 1.41675L13.3239 3.988" stroke="black" strokeWidth="1.0625" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M1.41699 5.56047C1.41699 4.25005 2.11824 4.1438 2.98949 4.1438H14.0112C14.8824 4.1438 15.5837 4.25005 15.5837 5.56047C15.5837 7.08338 14.8824 6.97713 14.0112 6.97713H2.98949C2.11824 6.97713 1.41699 7.08338 1.41699 5.56047Z" stroke="black" strokeWidth="1.0625"/>
                      <path d="M6.91309 9.91675V12.4313" stroke="black" strokeWidth="1.0625" strokeLinecap="round"/>
                      <path d="M10.1719 9.91675V12.4313" stroke="black" strokeWidth="1.0625" strokeLinecap="round"/>
                      <path d="M2.47949 7.08325L3.47824 13.2033C3.70491 14.5774 4.25033 15.5833 6.27616 15.5833H10.5474C12.7503 15.5833 13.0762 14.6199 13.3312 13.2883L14.5212 7.08325" stroke="black" strokeWidth="1.0625" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <span className={styles.iconLabel}>Корзина</span>
                  {cart.count > 0 && (
                    <span className={styles.cartCount}>
                      {cart.count > 99 ? '99+' : cart.count}
                    </span>
                  )}
                </a>

              </div>

              <div className={styles.privacyLink}>

                <a href={options.link_ofer} className={styles.privacyLinkText}>Договор оферты</a>

                <a href={options.link_pconf} className={styles.privacyLinkText}>Политика конфиденциальности</a>

                <a href="https://kulibin-it.ru/" target='_blank' className={styles.privacyLinkText}><b>Сайт разработал Kulibin-it.ru</b></a>

              </div>
            </div>
          </Container>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  options: PropTypes.object,
  menu: PropTypes.array,
  catalog: PropTypes.array,
  changeTopSearch: PropTypes.func,
  changeSearch: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array,
  user_profile_type: PropTypes.string,
  authorized: PropTypes.bool
}

export default Footer;